import { render } from "./LanguageDropdown.vue?vue&type=template&id=166883f4"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=166883f4&lang=scss"
script.render = render

export default script